export var accessibilityTranslations = {
    PRIVATE: { id: "ui-br-agency.product.accessibility.PRIVATE" },
    PUBLIC: { id: "ui-br-agency.product.accessibility.PUBLIC" },
};
export var getAccessibilityTranslation = function (intl, key) {
    if (!key)
        return "";
    var translation = accessibilityTranslations[key];
    if (!translation)
        return key;
    return intl.formatMessage(translation);
};
